import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import store from "../src/API/Store/store";
import "./index.css";
import "bootstrap/dist/css/bootstrap.min.css";
import App from "./App";
import { Provider } from "react-redux";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import reportWebVitals from "./reportWebVitals";
import { render } from "react-dom";
import { ModalProvider } from "./Components/ConfirmationModal/ModalContext";
const root = document.getElementById("root");
const queryClient = new QueryClient();

render(
  <React.StrictMode>
    <Provider store={store}>
      <QueryClientProvider client={queryClient}>
      <ModalProvider>
        <BrowserRouter>
          <App />
        </BrowserRouter>
        </ModalProvider>
      </QueryClientProvider>
    </Provider>
  </React.StrictMode>,
  root
);

// Register service worker
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/service-worker.js')
      .then((registration) => {
        // console.log('[SW] Registered: ', registration);

        // Listen for page focus to trigger cache clearing
        window.addEventListener('focus', () => {
          if (registration.active) {
            registration.active.postMessage({ type: 'CLEAR_CACHE' });
            // console.log('[SW] Clear cache message sent');
          }
        });
      })
      .catch((err) => console.error('[SW] Registration failed:', err));
  });
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
